ACC.profile = {

    _autoload: [
        'initialize',
        'trackFormChanges',
        'showCancelProfileChangesConfirmation',
        'bindCountryStates',
        'institutionAutocomplete',
    ],

    spinner: $(`<img src='${ACC.config.commonResourcePath}/images/spinner.gif' />`),

    initialize() {
        if ($('#updateProfileToken').length > 0 && piSession) {
            piSession.getToken((status, token) => {
                $('#updateProfileToken').val(token);
                $('#updateProfileUserId').val(piSession.userId());
            });
        }
    },

    trackFormChanges() {
        $('#updatePearsonProfileForm').on('change', () => {
            $('#updatePearsonProfileForm').data('changed', true);
        });
    },

    showCancelProfileChangesConfirmation() {
        $('.js-cancel-profile-changes-popup-button').on('click', function () {
            if ($('#updatePearsonProfileForm').data('changed')) {
                $modal.open(this);
            } else {
                window.location = $(this).data('cancelUrl');
            }
        });
    },

    bindCountryStates() {
        $('#defaultAddressCountrySelector').on('change', function () {
            ACC.registerPersona.displayStatesForChosenCountry(
                { countryIsoCode: $(this).val() },
                $('#countryAddressData'),
                ACC.registerPersona.spinner,
            );
        });
    },

    displayStatesForChosenCountry(options, countryAddressData, spinner) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/my-account/displayStates`,
            async: true,
            data: options,
            dataType: 'html',
            beforeSend() {
                countryAddressData.html(spinner);
            },
        }).done((data) => {
            countryAddressData.empty();
            countryAddressData.append($(data).html());
        });
    },

    institutionAutocomplete() {
        const institutionInputId = $('#profile-institution-id');
        const institutionInputName = $('#profile-institution-name');
        const institutionInput = $('#profile-institution-component');
        const inputResetBtn = $('.profile-institution-reset-btn');
        let institutionInputInitValue = institutionInput.val();
        let noResultMessage;
        let errorMessage;
        let selectLabel;
        let inputCurrentValue;

        function institutionInputOnLoad(inputId, input) { // Fix for FF, on page reload
            input.prop('value', input.attr('value'));
            if (!input.prop('value')) {
                inputId.val('');
            }
        }

        institutionInputOnLoad(institutionInputId, institutionInput);

        function institutionInputStr(input, event) { // Check if input value is empty
            inputCurrentValue = $.trim(input.val());
            if (inputCurrentValue.length === 0) {
                event.preventDefault();
                return false;
            }
            return encodeURIComponent(inputCurrentValue); // Encode input value before request
        }

        institutionInput.autocomplete({
            source(request, response) {
                $.ajax({
                    dataType: 'json',
                    type: 'GET',
                    headers: { 'X-Failover-Testing': 'PMC_No_Fail_Over' },
                    // eslint-disable-next-line max-len
                    url: `${ACC.config.encodedContextPath}/my-account/institutions?institution=${institutionInputStr(institutionInput)}`,
                    success(data) {
                        if (!data.length) {
                            noResultMessage = ACC.institutionMismatchingError;
                            const result = [{ label: noResultMessage, value: response.term }];
                            institutionInput.autocomplete('option', 'autoFocus', false);
                            response(result);
                        } else {
                            institutionInput.autocomplete('option', 'autoFocus', true);
                            response($.map(data, (item) => ({
                                label: item.aggregateName,
                                value: item.id,
                            })));
                        }
                    },
                    error(jqXHR) {
                        errorMessage = jqXHR.responseJSON;
                        const result = [{ label: errorMessage, value: response.term }];
                        institutionInput.autocomplete('option', 'autoFocus', false);
                        response(result);
                    },
                });
            },
            appendTo: '.profile-institution-wrapper',
            autoFocus: true,
            delay: 500,
            minLength: 3,
            focus(event) {
                event.preventDefault();
                return false;
            },
            select(event, ui) {
                selectLabel = ui.item.label;
                if (selectLabel === noResultMessage || selectLabel === errorMessage) {
                    event.preventDefault();
                    institutionInput.val(institutionInputInitValue).blur();
                    inputResetBtn.removeClass('show');
                    return false;
                }
                institutionInputId.val(ui.item.value);
                institutionInputName.val(ui.item.label);
                institutionInput.val(selectLabel).blur();
                return false;
            },
        });

        function inputResetBtnShowing(input) { // Handler for showing input reset button
            input.on('input', function () {
                inputCurrentValue = $(this).val();
                if (inputCurrentValue) {
                    inputResetBtn.addClass('show');
                } else {
                    institutionInput.val('');
                    inputResetBtn.removeClass('show');
                }
            });
            input.focus(function () {
                inputCurrentValue = $(this).val();
                if (inputCurrentValue) {
                    inputResetBtn.addClass('show');
                }
            });
        }

        inputResetBtnShowing(institutionInput);

        // eslint-disable-next-line consistent-return
        institutionInput.blur(function () { // Focus out handler for institution input field
            setTimeout(() => { // Fix for reset button click on focus out
                inputResetBtn.removeClass('show');
            }, 300);
            inputCurrentValue = $(this).val();

            // Check if input value is changed
            if (inputCurrentValue !== institutionInputInitValue) {
                // Check if autosudgest is available and no error case
                // eslint-disable-next-line max-len
                if (!!selectLabel && !(selectLabel === noResultMessage || selectLabel === errorMessage)) {
                    // Populate value from autosudgest in initial state
                    institutionInputInitValue = selectLabel;

                    // Populate value from autosudgest in input value
                    institutionInput.val(institutionInputInitValue);
                    return false;
                }
                // Check if input value not empty or changed, when wasn't
                // chosen from autosudgest list
                if (!!inputCurrentValue && inputCurrentValue !== institutionInputInitValue) {
                    // eslint-disable-next-line max-len
                    institutionInput.val(institutionInputInitValue); // Revert to initial input state
                    institutionInput.focus();
                } else {
                    institutionInput.val(''); // Clear input value on delete value
                    // eslint-disable-next-line max-len
                    institutionInputInitValue = inputCurrentValue; // Update initial input state to empty value
                }
            }
        });

        function inputResetBtnClick(button) { // On click handler for input reset button
            button.click(() => {
                institutionInput.val('');
                institutionInputId.val('');
                button.removeClass('show');
                $('#updatePearsonProfileForm').data('changed', true);
            });
        }

        inputResetBtnClick(inputResetBtn);
    },
};
